import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, LoginResponse } from '../service/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  rememberMe: boolean = false;
  errorMessage: string = '';
  isLoading: boolean = false;
  showPassword: boolean = false;
  currentYear: number = new Date().getFullYear();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // Check if user is already logged in
    if (this.authService.isAuthenticated()) {
      const lastUrl = this.authService.getLastUrl();
      this.router.navigate([lastUrl]);
    }
  }

  onSubmit() {
    if (!this.username || !this.password) {
      this.errorMessage = 'Veuillez remplir tous les champs';
      return;
    }

    // Basic validation for email format if it looks like an email
    if (this.username.includes('@') && !this.isValidEmail(this.username)) {
      this.errorMessage = 'Format d\'email invalide';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.authService.login(this.username, this.password, this.rememberMe)
      .subscribe({
        next: (response: LoginResponse) => {
          this.isLoading = false;
          // Navigate to the last URL or default route
          const lastUrl = this.authService.getLastUrl();
          this.router.navigate([lastUrl]);
        },
        error: (error: any) => {
          this.isLoading = false;
          this.errorMessage = error?.message || 'Nom d\'utilisateur/email ou mot de passe incorrect';
        }
      });
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
} 